import { produce } from "../../../../../../../../../../../libs/immer";
import { unformatValue, validateInput } from "../utils";
export var validateSum = function validateSum(_ref) {
  var getContent = _ref.getContent;
  return function (getState, setState) {
    var state = getState();
    var content = getContent();
    var result = unformatValue(state.sumInput.value);
    var _error = validateInput({
      value: result,
      texts: content.sumInputErrorTexts,
      bounds: [content.paymentParams.amount.min, content.paymentParams.amount.max]
    });
    if (!_error) return undefined;
    setState(function (prev) {
      return produce(prev, function (draft) {
        draft.sumInput.errorMessage = _error;
      });
    });
    return _error;
  };
};